export const IMPORT_CSVGET_REQUEST = "IMPORT_CSVGET_REQUEST";
export const IMPORT_CSVGET_SUCCESS = "IMPORT_CSVGET_SUCCESS";
export const IMPORT_CSVGET_FAIL = "IMPORT_CSVGET_FAIL";
